import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Utils } from "../../common/utils";
import { DashCred } from "./../../models/dash";
import { VproService } from "./../../service/vpro/vpro.service";
import { NgxSpinnerService } from "ngx-spinner";
import { SocketsConnectionService } from "./../../service/websockets/connection.service";


declare var $: any;
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  showComponent = true;
  dcred = new DashCred();
  userImg: String;
  display_name: String;
  usid: String;
  user_type: any;
  checkutype: any;
  checkutype2: any;
  page: number = 1;
  count: number = 10;
  public notificationData = {
    notifications: [],
    total_count: 0,
    total_unread: 0
  };
  avatarimg: string;
  constructor(private router: Router,
    private vproService: VproService,
    private utils: Utils,
    private spinner: NgxSpinnerService,
    private socketsConnectionService: SocketsConnectionService) { }

  ngOnInit() {
    this.dcred.usereid = localStorage.getItem("LogUsr");
    this.user_type = JSON.parse(localStorage.getItem("LogUsrTyp"));
    this.checkutype = this.user_type.some(item => item.name === 'physician');
    this.checkutype2 = this.user_type.some(item => item.name === 'admin' || item.name === 'front desk');
    let user_id = JSON.parse(localStorage.getItem("uid"));
    this.getUserById(this.user_type, user_id);
    this.getNotifications();
    this.vproService.notificationUpdate.subscribe(data => {
      if (data) this.handleNotiUpadtes(data);
    });
  }

  handleNotiUpadtes(data) {
    let { type } = data;
    switch (type) {
      case 'count':
        if (this.notificationData && this.notificationData.total_unread) this.notificationData.total_unread++;
    }
  }

  getNotifications(fromBell = false) {
    if (fromBell) this.page = 1;
    this.vproService.getNotificationByUser(JSON.parse(localStorage.getItem("uid")),
      this.page,
      this.count
    ).subscribe(
      (response: any) => {
        let { notifications, total_count, total_unread } = response;
        if (notifications && notifications.length > 0) {
          this.notificationData.notifications = fromBell ? notifications : [...this.notificationData.notifications, ...notifications];
        }
        if (total_count) this.notificationData.total_count = total_count;
        if (total_unread) this.notificationData.total_unread = total_unread;
      },
      (error) => { }
    );
  }

  readNoti(notification) {
    if (!notification.read) {
      this.spinner.show();
      this.vproService.updateNotification(notification.id,
        {
          read: true
        }
      ).subscribe(
        (response) => {
          this.spinner.hide();
          this.getNotifications();
        },
        (error) => { this.spinner.hide(); }
      );
    }
  }

  getUserById(type, id) {
    // this.userImg = environment.content_base_url + "/" + environment.dummy_img;
    let observable = null;
    if (this.utils.checkRoleType(Utils.USER_TYPE.physician, type)) {
      observable = this.vproService.getPhysicianById(id);
    } else if (this.utils.checkRoleType(Utils.USER_TYPE.front_desk, type)) {
      observable = this.vproService.getFrontDeskById(id);
    }
    else if (this.utils.checkRoleType(Utils.USER_TYPE.admin, type)) {
      observable = this.vproService.getFrontDeskById(id);
    }

    if (observable) {
      observable.subscribe(
        (response) => {
          if (response && response.ppurl) {
            this.userImg = response.ppurl;
            this.avatarimg = this.userImg.substring(this.userImg.lastIndexOf('/') + 1);
          }
          if (response && response.first_name) {
            this.display_name = response.first_name + ' ' + (response.last_name ? response.last_name : '');
          } else {
            this.display_name = response.email_id;
          }
          let paid_account_status;
          if ("paid_account" in localStorage)
            paid_account_status = localStorage.getItem("paid_account");

          if (response && response.paid_account)
            localStorage.setItem("paid_account", response.paid_account);
          else {
            if (response.paid_account != localStorage.getItem("paid_account"))
              localStorage.setItem("paid_account", response.paid_account);
          }
          if (paid_account_status != localStorage.getItem("paid_account")) {
            window.location.reload();
          }

          this.usid = response.u_id;
          localStorage.setItem("first_name", response.first_name);
          localStorage.setItem("last_name", response.last_name);
        },
        (error) => { }
      );
    }
  }

  logout() {
    let data = JSON.parse(localStorage.getItem("LogUsrTyp"));
    if (JSON.parse(localStorage.getItem("remember"))) {
      let u_name = localStorage.getItem("username");
      let pwd = localStorage.getItem("password");
      let rem = localStorage.getItem("remember");
      localStorage.clear();
      localStorage.setItem("username", u_name);
      localStorage.setItem("password", pwd);
      localStorage.setItem("remember", rem);
    }
    else
      localStorage.clear();
    this.socketsConnectionService.disconnect();

    if (this.utils.checkRoleType(Utils.USER_TYPE.superadmin, data))
      this.router.navigate(["/login"], { queryParams: { role: "superadmin" } });
    else
      this.router.navigate(["/login"]);

  }

  /** toggle sidebar */
  public toggleSideBar(event: MouseEvent): void {
    event.preventDefault();
    var body = $("body");
    var bodyposition = body.css("position");
    //  if (bodyposition != 'relative') {
    //   if (!body.hasClass('sidebar-collapsed')) {
    //     body.addClass('sidebar-collapsed');
    //     $('.side-navigation ul').attr('style', '');
    //   } else {
    //     body.removeClass('sidebar-collapsed chat-view');
    //     $('.side-navigation li.active ul').css({ display: 'block' });
    //   }
    // } else {
    //   if (body.hasClass('sidebar-open'))
    //     body.removeClass('sidebar-open');
    //   else
    //     body.addClass('sidebar-open');
    //   this.adjustMainContentHeight();
    // }
    if (!body.hasClass("sidebar-collapsed")) {
      body.addClass("sidebar-collapsed");
      $(".side-navigation ul").attr("style", "");
    } else {
      body.removeClass("sidebar-collapsed chat-view");
      $(".side-navigation li.active ul").css({ display: "block" });
    }
    // this.adjustMainContentHeight();
  }
  /** adjusting content height */
  private adjustMainContentHeight(): void {
    // Adjust main content height
    var docHeight = $(document).height();
    if (docHeight > $(".body-content").height())
      $(".body-content").height(docHeight);
  }

  onScroll() {
    if (this.notificationData.total_count > (this.page * this.count)) {
      this.page++;
      this.getNotifications();
    }
  }
}
